import {IEntitiesState,IENTITIESActionCreator,IEntityActionTypes} from 'models/IEntitiesState';

const initialState:IEntitiesState[] = []

const reducer = (state = initialState, { type, payload }: IENTITIESActionCreator) => {
    switch (type) {
      case IEntityActionTypes.FETCH_ENTITIES_LIST_REQUEST:
        return {
          ...state,
          data:[],
        }
      case IEntityActionTypes.FETCH_ENTITIES_LIST_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;